 document.addEventListener('DOMContentLoaded', function() {
    var buyNowButton = document.getElementById('buy-now-button');
    if (buyNowButton) {
      buyNowButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Get the selected variant id. In Dawn, the variant input is usually named "id".
        var variantInput = document.querySelector('form [name="id"]');
        if (!variantInput) {
          console.error("Variant selector not found.");
          return;
        }
        var variantId = variantInput.value;
        // Optionally get quantity if your form has an input named "quantity"
        var quantityInput = document.querySelector('form [name="quantity"]');
        var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
        
        // Build the data for the AJAX request
        var data = {
          items: [{
            id: variantId,
            quantity: quantity
          }]
        };
        
        // Make the AJAX call to add the product to the cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then(function(response) {
          if (response.ok) {
            // Redirect to checkout on successful add-to-cart
            window.location.href = '/checkout';
          } else {
            // If there’s an error, you might want to handle it here
            response.json().then(function(errorData) {
              console.error('Error adding to cart:', errorData);
              alert('There was an issue adding the product to the cart.');
            });
          }
        })
        .catch(function(error) {
          console.error('Fetch error:', error);
          alert('There was a network error. Please try again.');
        });
      });
    }
  });
